/** Formatting shared by every page, so the same value never reads two different ways. */

const dateTime = new Intl.DateTimeFormat('it-IT', { dateStyle: 'medium', timeStyle: 'medium' });
const timeOnly = new Intl.DateTimeFormat('it-IT', { timeStyle: 'medium' });
const decimal = new Intl.NumberFormat('it-IT');

export const formatDateTime = (value: string | null | undefined): string => (value ? dateTime.format(new Date(value)) : '—');

export const formatTime = (value: string | null | undefined): string => (value ? timeOnly.format(new Date(value)) : '—');

export const formatNumber = (value: number | null | undefined): string => (value === null || value === undefined ? '—' : decimal.format(value));

/** Durations read better with the unit that keeps them short: 940 ms, 2,4 s, 3 min. */
export function formatDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return '—';
  if (ms < 1000) return `${Math.round(ms)} ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(1).replace('.', ',')} s`;
  return `${Math.round(ms / 60_000)} min`;
}

export function formatRelative(value: string | null | undefined): string {
  if (!value) return '—';
  const delta = Date.now() - Date.parse(value);
  if (delta < 60_000) return 'adesso';
  if (delta < 3_600_000) return `${Math.round(delta / 60_000)} min fa`;
  if (delta < 86_400_000) return `${Math.round(delta / 3_600_000)} h fa`;
  return formatDateTime(value);
}

export const truncate = (value: string, max = 12): string => (value.length <= max ? value : `${value.slice(0, max)}…`);
